"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopover = exports.StyledTargetWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CalciteThemeProvider = require("../CalciteThemeProvider");

var _MenuStyled = require("../Menu/Menu-styled");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// Copyright 2019 Esri
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​
// styled-components
// Utils, common elements
// Calcite theme and Esri colors
// Calcite components
// Icons
// Third party libraries
var StyledTargetWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledTargetWrapper",
  componentId: "sc-1pr6w5t-0"
})(["display:inline-block;"]);

exports.StyledTargetWrapper = StyledTargetWrapper;
StyledTargetWrapper.defaultProps = {
  theme: _CalciteThemeProvider.CalciteTheme
};

var StyledPopover = _styledComponents.default.div.withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1pr6w5t-1"
})(["box-shadow:0 0 16px 0 rgba(0,0,0,0.05);opacity:0;transition:opacity ", "ms cubic-bezier(0.4,0,0.2,1);z-index:2000;pointer-events:none;&[data-x-out-of-boundaries]{display:none;}", ";", ";", "{box-shadow:none;}iframe{border:none;}"], function (props) {
  return props.transitionDuration;
}, function (props) {
  return props.transitionState === 'entering' && (0, _styledComponents.css)(["opacity:0;pointer-events:auto;"]);
}, function (props) {
  return props.transitionState === 'entered' && (0, _styledComponents.css)(["opacity:1;pointer-events:auto;"]);
}, _MenuStyled.StyledMenu);

exports.StyledPopover = StyledPopover;
StyledPopover.defaultProps = {
  theme: _CalciteThemeProvider.CalciteTheme
};